import React, { useEffect, useState,useContext } from 'react';
import axios from 'axios';
import { AppContext } from '../../context/AppContext';
import { useApiClient } from '../../ApiService/useApiClient';



function PaymentMethodsList({ customerId }) {

  const api = useApiClient();
  const { user , token} = useContext(AppContext);  
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!customerId) return;


    const baseURL = "api/payments/get-payment-methods/"+customerId;

   

    const fetchPaymentMethods = async () => {
      try {
        const response = await api.get(baseURL);
        setPaymentMethods(response.data);
       // console.log(response.data);

      } catch (err) {
        setError('Failed to load payment methods.');
        console.error(err);
      }
    };

    fetchPaymentMethods();
  }, [customerId]);

  if (!customerId) return <p>Please provide a Stripe customer ID.</p>;
  if (error) return <p>{error}</p>;

  return (
    <div>
      {/* <h4>Saved Payment Methods</h4> */}
      {paymentMethods.length === 0 ? (
        <p>No payment methods found.</p>
      ) : (
        <ul>
          {paymentMethods.map((pm) => (
            <li key={pm.id}>
              {pm.brand?.toUpperCase()} **** {pm.last4} — Expires {pm.expMonth}/{pm.expYear}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default PaymentMethodsList;
